import React from 'react'
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'
import WindowSizeListener from 'react-window-size-listener'
import { ToastContainer } from 'react-toastify'
import smoothscroll from 'smoothscroll-polyfill'

import { facebookLiveChatInit } from './utils/facebookLiveChat'

import './styles/reset.scss'

import 'react-toastify/dist/ReactToastify.min.css'

import './styles/main.scss'

// Animate.css https://animate.style/
import 'animate.css'

import 'simplebar/dist/simplebar.min.css'

import GA from './utils/GoogleAnalytics'

import { UTILS__VALIDATOR__is_json } from './utils/validator'

import {
    AUTH__SET,
    USER__SET,
    USER__SET_DETAILS,
    TOKEN__SET,
    SERVICE__STYLES__SET_WINDOW_SIZES,
    COMMON__SET_LANGUAGE,
    COMMON__SET_APP_LOADED,
} from './store/actions'

import ScrollToTop from './routes/utils/ScrollToTop'
import { API__USER } from './api'

// Routes
import AuthRoutes from './routes/Auth'
import MainRoutes from './routes/Main'
import ErrorRoutes from './routes/Error'

import SEO from './components/SEO'

import oauth from './pages/oauthLogin'
import ErrorBoundary from './common/components/ErrorBoundary/ErrorBoundary'

smoothscroll.polyfill()

class App extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            initGA: false,
        }
    }

    async componentDidMount() {
        this._isMounted = true

        const {
            i18n: { language },
        } = this.props

        try {
            const { P__COMMON__SET_LANGUAGE } = this.props

            await P__COMMON__SET_LANGUAGE(language)

            // Initial state's
            const user = localStorage.getItem('user')
            const token = localStorage.getItem('token')

            let data_is_correct = false
            if (user && token) {
                if (UTILS__VALIDATOR__is_json(user) && UTILS__VALIDATOR__is_json(token)) {
                    data_is_correct = true

                    const { P__AUTH__SET, P__USER__SET, P__TOKEN__SET, P__USER__SET_DETAILS } = this.props

                    const _user = JSON.parse(user)
                    const _token = JSON.parse(token)

                    await P__AUTH__SET(true)
                    await P__USER__SET(_user)
                    await P__TOKEN__SET(_token)

                    const response_1 = await API__USER.GET_DETAILS(_user.id)

                    await P__USER__SET_DETAILS(response_1)
                }
            }
            if (!data_is_correct) {
                localStorage.removeItem('user')
                localStorage.removeItem('token')
            }
        } catch (err) {
            console.error(err)
        } finally {
            if (this._isMounted) {
                const { P__COMMON__SET_APP_LOADED } = this.props
                await P__COMMON__SET_APP_LOADED(true)

                await this.setState({ initGA: true })

                // Facebook Live Chat
                setTimeout(facebookLiveChatInit, 5000, language.replace('-', '_'))
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    onResize__window = async data => {
        const { P__SERVICE__STYLES__SET_WINDOW_SIZES } = this.props
        await P__SERVICE__STYLES__SET_WINDOW_SIZES({
            width: data.windowWidth,
            height: data.windowHeight,
        })
    }

    render() {
        const { initGA } = this.state
        const {
            i18n: { language },
        } = this.props

        return (
            <ErrorBoundary isShowReloadBtn>
                <div className="wrapper">
                    <SEO
                        title="Create interactive content in minutes. Free"
                        addTitleLabel={false}
                        description="One of the most powerful editors for interactive content. Create quizzes, photogalleries and games. Generate leads, collect data and drive more traffic. Start with a template. Customize like never before. Get maximum efficiency with detailed analytics and integrations."
                        thumbnail="/sharing.png"
                        thumbnailType="image/png"
                        thumbnailWidth="1000"
                        thumbnailHeight="672"
                        locale={language}
                    />

                    <WindowSizeListener onResize={this.onResize__window} />
                    <Router>
                        {/* Google Analytics */}
                        {initGA ? GA.init() && <GA.RouteTracker /> : null}

                        <ScrollToTop />

                        {/*<Suspense fallback={<></>}>*/}
                        <Switch>
                            <Route exact path={['/auth']} component={AuthRoutes} />
                            <Route
                                exact
                                path={[
                                    '/',
                                    '/template-gallery/:id?',
                                    '/about',
                                    '/contacts',
                                    '/investors',
                                    '/how-it-works',
                                    '/pricing/:type',
                                    '/cookie-policy',
                                    '/data-processing-agreement',
                                    '/privacy-policy',
                                    '/terms-of-use',
                                    '/policy',
                                    '/products/:name',
                                    '/404',
                                ]}
                                component={MainRoutes}
                            />
                            <Route
                                path={[
                                    '/account/settings',
                                    '/account/billing-and-payments',
                                    '/account/my-projects',
                                    '/account/editor',
                                    '/editor',
                                    // '/oauth2/successful-registration',
                                ]}
                                component={MainRoutes}
                            />
                            <Route exact path={['/error']} component={ErrorRoutes} />

                            <Route exact path={['/oauth2/redirect']} component={oauth} />

                            {/*Redirect for old links*/}
                            <Redirect from="/landing/:name" to="/products/:name" />
                            {/*Redirect if path not found*/}
                            <Redirect from="*" to="/" />
                        </Switch>
                        {/*</Suspense>*/}
                    </Router>
                    <ToastContainer />
                    <div
                        id="editor-tip__fb-mock"
                        style={{ position: 'absolute', right: '24px', bottom: '24px', width: '60px', height: '60px' }}
                    ></div>
                </div>
            </ErrorBoundary>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        P__SERVICE__STYLES__SET_WINDOW_SIZES: obj => dispatch(SERVICE__STYLES__SET_WINDOW_SIZES(obj)),
        P__COMMON__SET_LANGUAGE: value => dispatch(COMMON__SET_LANGUAGE(value)),
        P__AUTH__SET: value => dispatch(AUTH__SET(value)),
        P__USER__SET: obj => dispatch(USER__SET(obj)),
        P__USER__SET_DETAILS: obj => dispatch(USER__SET_DETAILS(obj)),
        P__TOKEN__SET: obj => dispatch(TOKEN__SET(obj)),
        P__COMMON__SET_APP_LOADED: value => dispatch(COMMON__SET_APP_LOADED(value)),
    }
}

export default compose(connect(null, mapDispatchToProps), withTranslation('translations'))(App)
